/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_01_Detail_Beginner_2_HeadingInputs */

const en_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What comes after setup`)
};

const es_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué viene después del setup`)
};

const de_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was kommt nach der Einrichtung?`)
};

const zh_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`准备姿势之后`)
};

const ar_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما يأتي بعد الإعداد`)
};

const fr_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que se passe-t-il après la mise en place`)
};

const vi_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều gì đến sau setup`)
};

const sw_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinachofuata baada ya maandalizi`)
};

const th_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หลังจากการจัดท่าก่อนตี`)
};

const bs_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šta dolazi poslije setupa`)
};

const ja_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セットアップのあとに来るもの`)
};

const ko_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`셋업 다음에 오는 것`)
};

const pt_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que vem depois da preparação`)
};

const it_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che cosa viene dopo il setup`)
};

const sv_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vad som kommer efter uppställningen`)
};

const nl_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat er na de opstelling komt`)
};

const da_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad der kommer efter opstillingen`)
};

const nb_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hva som kommer etter oppstillingen`)
};

const fi_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitä lähtöasennon jälkeen tulee`)
};

const pl_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co przychodzi po ustawieniu`)
};

const ru_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что идёт после исходной позиции`)
};

const tr_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hazırlıktan sonra ne gelir`)
};

const hi_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटअप के बाद क्या आता है`)
};

const id_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa selanjutnya setelah setup`)
};

const ms_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa seterusnya selepas persediaan`)
};

const cs_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co přichází po postavení`)
};

const el_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τι ακολουθεί μετά την προετοιμασία`)
};

const he_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מה בא אחרי עמידת הפתיחה`)
};

const af_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat ná die opstelling kom`)
};

const hu_method_content_step_01_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi jön az alapállás után`)
};

/**
* | output |
* | --- |
* | "What comes after setup" |
*
* @param {Method_Content_Step_01_Detail_Beginner_2_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_01_detail_beginner_2_heading = /** @type {((inputs?: Method_Content_Step_01_Detail_Beginner_2_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_01_Detail_Beginner_2_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "de") return de_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "zh") return zh_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "ar") return ar_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "fr") return fr_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "vi") return vi_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "sw") return sw_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "th") return th_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "bs") return bs_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "ja") return ja_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "ko") return ko_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "pt") return pt_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "it") return it_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "sv") return sv_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "nl") return nl_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "da") return da_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "nb") return nb_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "fi") return fi_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "pl") return pl_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "ru") return ru_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "tr") return tr_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "hi") return hi_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "id") return id_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "ms") return ms_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "cs") return cs_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "el") return el_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "he") return he_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "af") return af_method_content_step_01_detail_beginner_2_heading(inputs)
	if (locale === "hu") return hu_method_content_step_01_detail_beginner_2_heading(inputs)
	return en_method_content_step_01_detail_beginner_2_heading(inputs)
});